import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: /admin/* children render through here.
// The dashboard itself lives at ./index.tsx ("/admin/").
export const Route = createFileRoute("/admin")({
  component: () => <Outlet />,
});
